module.exports = ".photo_gallery_pic{background-size:cover !important;position:relative !important}\n"